export default "__VITE_ASSET__494b5319__"